import React from "react";
import { Accordion, Paper, Text, ThemeIcon } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import type { EventDto } from "../types";
import type { Texts } from "../texts";

type Props = {
    eventInfo: EventDto | null;
    t: Texts;
};

export default function InfoSection({ eventInfo, t }: Props) {
    if (!eventInfo?.infoText?.trim()) return null;

    return (
        <Accordion.Item value="info">
            <Accordion.Control
                icon={
                    <ThemeIcon color="red" variant="light" radius="xl">
                        <IconInfoCircle size={18} />
                    </ThemeIcon>
                }
            >
                {t.info}
            </Accordion.Control>

            <Accordion.Panel>
                <Paper withBorder p="sm" radius="md">
                    <Text fw={600} mb={6}>
                        {t.importantInfo}
                    </Text>

                    <Text style={{ whiteSpace: "pre-wrap" }}>
                        {eventInfo.infoText}
                    </Text>
                </Paper>
            </Accordion.Panel>
        </Accordion.Item>
    );
}